import { render, staticRenderFns } from "./TabletControl.vue?vue&type=template&id=563916a2&scoped=true&"
import script from "./TabletControl.vue?vue&type=script&lang=js&"
export * from "./TabletControl.vue?vue&type=script&lang=js&"
import style0 from "./TabletControl.vue?vue&type=style&index=0&id=563916a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563916a2",
  null
  
)

export default component.exports